export default class Modal {
  constructor(el) {
    this.previouslyFocus = null
    this.el              = el
    this.active          = false
    this.openButton      = document.querySelector('.search-modal-open')
    this.closeButton     = document.querySelector('.search-modal-close')
    this.searchField     = document.querySelector('.search-modal-input')

    this.openButton.addEventListener('click', this.activate.bind(this))
    this.closeButton.addEventListener('click', this.deactivate.bind(this))
    document.addEventListener('keydown', this.closeOnESC.bind(this))
  }

  activate(e) {
    e && e.preventDefault()

    this.active = true

    this.previouslyFocus = document.activeElement

    this.el.classList.add('-active')

    setTimeout(function() {
      this.searchField.focus()
    }.bind(this), 200)
  }

  deactivate(e) {
    e && e.preventDefault()

    this.active = false

    this.previouslyFocus.focus()

    this.el.classList.remove('-active')
  }

  closeOnESC(e) {
    if (e.keyCode == 27 && this.active) {
      this.deactivate()
    }
  }
}



// WEBPACK FOOTER //
// ./src/javascript/features/modal.js